import styled from 'styled-components';
import { alpha } from '@wojtekmaj/color-utils';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

const fbColors = {
  primary: '#1877f2',
  primaryDark: '#0c64b6',
};

export const Button = styled(CommonButton)`
  --fb-primary: ${fbColors.primary};
  --fb-dark: ${fbColors.primaryDark};
  --secondary-button-border-width: 0px;
  display: inline-block;
  background: var(--fb-primary);
  box-shadow: 0px 2px 2px ${alpha(fbColors.primary, 0.05)},
    0px 5px 10px ${alpha(fbColors.primary, 0.1)};
  color: white;

  &:hover, &:focus {
    background: var(--fb-dark);
    color: white;
  }

  &:focus-visible {
    background: var(--fb-primary);
    box-shadow: 0px 0px 10px ${alpha(fbColors.primary, 0.6)};
    color: white;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  vertical-align: -26%;
`;
